<template>
  <div id="warehouseReceipt">
    <!-- PC端 -->
    <div
      class="warehouse_PC"
      v-if="deviceType == 'tablet' || deviceType == 'desktop'"
    >
      <div class="warehouse_PC_con">
        <!-- 表单标题 -->
        <div class="warehouse_PC_head">入库单确认</div>
        <!-- 警示 -->
        <div class="warehosue_PC_warning">
          <div class="warehouse_warning_chose">
            语言/language: &nbsp;&nbsp;&nbsp;&nbsp;<el-button
              @click="changeLang('CN')"
              :type="languageType == 'CN' ? 'primary' : 'default'"
              >中文</el-button
            >
            <el-button
              @click="changeLang('EN')"
              :type="languageType == 'EN' ? 'primary' : 'default'"
              >English</el-button
            >
          </div>
          <div class="warehouse_warn_words">
            注意:&nbsp;&nbsp;请务必认真填写货值并提交确认,此信息具有法律效应!
          </div>
        </div>
        <!-- 入仓单 -->
        <div class="warehouse_in_order">
          <div class="warehouse_order_choices">
            <div class="warehouse_choices_title">入仓单序号(点击查看详情)</div>
            <ul class="warehouse_choices_ul">
              <li
                :class="{
                  warehosue_choices_li: true,
                  active_preview: previewIndex == index
                }"
                @click="changePreviewIndex(index)"
                v-for="(item, index) in inOrderList"
                :key="index"
              >
                {{ index + 1 }}
              </li>
            </ul>
          </div>
          <div class="warehouse_orders">
            <div
              class="warehouse_orders_item"
              v-for="(item, index) in inOrderList"
              :key="index"
            >
              <div class="warehouse_item_title">
                <div
                  style="
                    display: flex;
                    flex: 1;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  客户:&nbsp;&nbsp;&nbsp;{{
                    languageType == "EN"
                      ? item.customername.en
                      : item.customername.cn
                  }}
                </div>
                <div class="warehouse_value_input">
                  <div class="warehouse_value_title">货值金额(USD):</div>
                  <el-input
                    :disabled="item.jobType.en == 'FBA'"
                    v-model="item.valueGoods.en"
                    type="number"
                    :min="0"
                    @input="handleMoneyInput(item.valueGoods.en, index)"
                    clearable
                  ></el-input>
                </div>
              </div>
              <div class="warehouse_orders_con">
                <!-- 1 -->
                <div class="warehouse_con_son">入仓号</div>
                <!-- 2 -->
                <div class="warehouse_con_son">
                  {{ languageType == "EN" ? item.inNos.en : item.inNos.cn }}
                </div>
                <!-- 3 -->
                <div class="warehouse_con_son">入仓时间</div>
                <!-- 4 -->
                <div class="warehouse_con_son">
                  {{
                    languageType == "EN"
                      ? item.inWarehouseTime.en
                      : item.inWarehouseTime.cn
                  }}
                </div>
                <!-- 5 -->
                <div class="warehouse_con_son">付款方</div>
                <!-- 6 -->
                <div class="warehouse_con_son">
                  {{ languageType == "EN" ? item.payType.en : item.payType.cn }}
                </div>
                <!-- 7 -->
                <div class="warehouse_con_son">清关方式</div>
                <!-- 8 -->
                <div class="warehouse_con_son">
                  {{
                    languageType == "EN"
                      ? item.customsType.en
                      : item.customsType.cn
                  }}
                </div>
                <!-- 9 -->
                <div class="warehouse_con_son">目的国</div>
                <!-- 10 -->
                <div class="warehouse_con_son">
                  {{
                    languageType == "EN"
                      ? item.countryName.en
                      : item.countryName.cn
                  }}
                </div>
                <!-- 11 -->
                <div class="warehouse_con_son">业务类型</div>
                <!-- 12 -->
                <div class="warehouse_con_son">
                  {{ languageType == "EN" ? item.jobType.en : item.jobType.cn }}
                </div>
                <!-- 13 -->
                <div class="warehouse_con_son">报关方式</div>
                <!-- 14 -->
                <div class="warehouse_con_son">
                  {{
                    languageType == "EN"
                      ? item.declareType.en
                      : item.declareType.cn
                  }}
                </div>
                <!-- 15 -->
                <div class="warehouse_con_son"></div>
                <!-- 16 -->
                <div class="warehouse_con_son">货物类型</div>
                <!-- 17 -->
                <div class="warehouse_con_son">
                  {{
                    languageType == "EN" ? item.goodsType.en : item.goodsType.cn
                  }}
                </div>
                <!-- 18 -->
                <div class="warehouse_con_son">件数</div>
                <!-- 19 -->
                <div class="warehouse_con_son">
                  {{ languageType == "EN" ? item.piece.en : item.piece.cn }}
                </div>
                <!-- 20 -->
                <div class="warehouse_con_son">重量(KG)</div>
                <!-- 21 -->
                <div class="warehouse_con_son">
                  {{ languageType == "EN" ? item.weight.en : item.weight.cn }}
                </div>
                <!-- 22 -->
                <div class="warehouse_con_son">体积(m³)</div>
                <!-- 23 -->
                <div class="warehouse_con_son">
                  {{ languageType == "EN" ? item.cbm.en : item.cbm.cn }}
                </div>
                <!-- 24 -->
                <div class="warehouse_con_son"></div>
                <!-- 25 -->
                <div class="warehouse_con_son"></div>
                <!-- 26 -->
                <div class="warehouse_con_son">计费重</div>
                <!-- 27 -->
                <div class="warehouse_con_son">
                  {{
                    languageType == "EN"
                      ? item.chargWeight.en
                      : item.chargWeight.cn
                  }}
                </div>
                <!-- 28 -->
                <div class="warehouse_con_son"></div>
                <!-- 29 -->
                <div class="warehouse_con_son"></div>
                <!-- 30 -->
                <div class="warehouse_con_son">品名</div>
                <!-- 31 -->
                <div class="warehouse_con_son">
                  {{
                    languageType == "EN" ? item.goodsName.en : item.goodsName.cn
                  }}
                </div>
                <!-- 32 -->
                <div class="warehouse_con_son" style="color: #ee3330">
                  {{
                    languageType == "EN"
                      ? item.brandName.en
                        ? item.brandName.en + "、"
                        : ""
                      : item.brandName.cn
                      ? item.brandName.cn + "、"
                      : ""
                  }}&nbsp;{{
                    languageType == "EN"
                      ? item.hasbatteryName.en
                        ? item.hasbatteryName.en + "、"
                        : ""
                      : item.hasbatteryName.cn
                      ? item.hasbatteryName.cn + "、"
                      : ""
                  }}&nbsp;{{
                    languageType == "EN"
                      ? item.powderliquidName.en
                        ? item.powderliquidName.en
                        : ""
                      : item.powderliquidName.cn
                      ? item.powderliquidName.cn
                      : ""
                  }}
                </div>
                <!-- 33 -->
                <div class="warehouse_con_son">客户单号</div>
                <!-- 34 -->
                <div class="warehouse_con_son">
                  {{ languageType == "EN" ? item.refno.en : item.refno.cn }}
                </div>
                <!-- 35 -->
                <div class="warehouse_con_son">物流单号</div>
                <!-- 36 -->
                <div class="warehouse_con_son">
                  {{
                    languageType == "EN"
                      ? item.logisticsNo.en
                      : item.logisticsNo.cn
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部提交栏 -->
        <div class="warehouse_PC_bottom">
          <div class="warehouse_bottom_first">
            <div style="color: rgb(224, 0, 17)">提交人:</div>
            <el-input v-model="submitMan" clearable></el-input>
          </div>
          <div class="warehouse_bottom_second">
            <el-button @click="submitFormVal(false)">保存</el-button>
            <el-button @click="submitFormVal(true)">确认并提交</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 移动端 -->
    <!-- <div class="warehouse_Mobile"> -->
    <div class="warehouse_Mobile" v-if="deviceType == 'mobile'">
      <div class="warehouse_Mobile_title">入库单确认</div>
      <div class="warehouse_Mobile_warning">
        <i class="el-icon-warning" style="color: #ee3330"></i>
        注意:请务必认真填写货值并提交确认,此信息具有法律效应!
      </div>
      <div class="warehouse_Mobile_con">
        <div class="warehouse_Mobile_lang">
          语言(Language):
          <div
            @click="changeMobileLang('CN')"
            :class="{
              Mobile_chose_btn: true,
              Mobile_btn_active: mobileLang == 'CN'
            }"
          >
            中文
          </div>
          <div
            @click="changeMobileLang('EN')"
            :class="{
              Mobile_chose_btn: true,
              Mobile_btn_active: mobileLang == 'EN'
            }"
          >
            English
          </div>
        </div>
        <!-- 客户入库单 -->
        <div class="warehouse_inOrder_list">
          <ul class="warehouse_inOrder_ul">
            <li
              class="warehouse_inOrder_li"
              v-for="(item, index) in inOrderList"
              :key="index"
            >
              <div class="inOrder_li_cus">客户:Bob(送货收款)</div>
              <div class="inOrder_li_money">
                <div>货值金额</div>
                <div>
                  <el-input
                    :disabled="item.jobType.en == 'FBA'"
                    type="number"
                    clearable
                    placeholder="请填写货值金额"
                    v-model="item.valueGoods.en"
                    @input="handleMoneyInput(item.valueGoods.en)"
                  >
                    <template slot="append">USD</template>
                  </el-input>
                </div>
              </div>
              <div class="inOrder_li_form">
                <div>
                  <div>入仓号</div>
                  <div>
                    {{ languageType == "EN" ? item.inNos.en : item.inNos.cn }}
                  </div>
                </div>
                <div>
                  <div>入仓时间</div>
                  <div>
                    {{
                      languageType == "EN"
                        ? item.inWarehouseTime.en
                        : item.inWarehouseTime.cn
                    }}
                  </div>
                </div>
                <div>
                  <div>付款方</div>
                  <div>
                    {{
                      languageType == "EN" ? item.payType.en : item.payType.cn
                    }}
                  </div>
                </div>
                <div>
                  <div>清关方式</div>
                  <div>
                    {{
                      languageType == "EN"
                        ? item.customsType.en
                        : item.customsType.cn
                    }}
                  </div>
                </div>
                <div>
                  <div>目的国</div>
                  <div>
                    {{
                      languageType == "EN"
                        ? item.countryName.en
                        : item.countryName.cn
                    }}
                  </div>
                </div>
                <div>
                  <div>业务类型</div>
                  <div>
                    {{
                      languageType == "EN" ? item.jobType.en : item.jobType.cn
                    }}
                  </div>
                </div>
                <div>
                  <div>报关方式</div>
                  <div>
                    {{
                      languageType == "EN"
                        ? item.declareType.en
                        : item.declareType.cn
                    }}
                  </div>
                </div>
                <div>
                  <div>货物类型</div>
                  <div>
                    {{
                      languageType == "EN"
                        ? item.goodsType.en
                        : item.goodsType.cn
                    }}
                  </div>
                </div>
                <div>
                  <div>其他属性</div>
                  <div style="color: #ee3330">
                    {{
                      languageType == "EN"
                        ? item.brandName.en
                          ? item.brandName.en + "、"
                          : ""
                        : item.brandName.cn
                        ? item.brandName.cn + "、"
                        : ""
                    }}&nbsp;{{
                      languageType == "EN"
                        ? item.hasbatteryName.en
                          ? item.hasbatteryName.en + "、"
                          : ""
                        : item.hasbatteryName.cn
                        ? item.hasbatteryName.cn + "、"
                        : ""
                    }}&nbsp;{{
                      languageType == "EN"
                        ? item.powderliquidName.en
                          ? item.powderliquidName.en
                          : ""
                        : item.powderliquidName.cn
                        ? item.powderliquidName.cn
                        : ""
                    }}
                  </div>
                </div>
                <div>
                  <div>件数</div>
                  <div>
                    {{ languageType == "EN" ? item.piece.en : item.piece.cn }}
                  </div>
                </div>
                <div>
                  <div>重量(KG)</div>
                  <div>
                    {{ languageType == "EN" ? item.weight.en : item.weight.cn }}
                  </div>
                </div>
                <div>
                  <div>体积(m³)</div>
                  <div>
                    {{ languageType == "EN" ? item.cbm.en : item.cbm.cn }}
                  </div>
                </div>
                <div>
                  <div>计费重</div>
                  <div>
                    {{
                      languageType == "EN"
                        ? item.chargWeight.en
                        : item.chargWeight.cn
                    }}
                  </div>
                </div>
                <div>
                  <div>品名</div>
                  <div
                    style="
                      white-space: nowrap;
                      word-break: break-all;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    "
                  >
                    {{
                      languageType == "EN"
                        ? item.goodsName.en
                        : item.goodsName.cn
                    }}
                  </div>
                </div>
                <div>
                  <div>客户单号</div>
                  <div>
                    {{ languageType == "EN" ? item.refno.en : item.refno.cn }}
                  </div>
                </div>
                <div>
                  <div>物流单号</div>
                  <div>
                    {{
                      languageType == "EN"
                        ? item.logisticsNo.en
                        : item.logisticsNo.cn
                    }}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- 底部提交人 -->
        <div class="mobile_submit_bottom" v-if="inOrderList.length > 0">
          <div class="mobile_submit_man">
            <div class="mobile_submit_contact">提交人</div>
            <el-input placeholder="请填写提交人"></el-input>
          </div>
          <div class="mobile_submit_btns">
            <el-button @click="submitFormVal(false)">保存</el-button>
            <el-button @click="submitFormVal(true)">确认并提交</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'warehouseReceipt',
  data() {
    return {
      // 提交人
      submitMan: '',
      // 屏幕显示宽度
      windowWidth: window.innerWidth,
      // 中英文:CN:中文，EN:英文
      languageType: 'CN',
      // 入仓单当前预览序号
      previewIndex: 0,
      // 入仓单
      inOrderList: [
        // {
        //   // 品牌
        //   brandName: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 体积
        //   cbm: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 计费重量
        //   chargWeight: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 柜号
        //   cntNo: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 目的国
        //   countryName: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 用户名
        //   customername: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 清关方式
        //   customsType: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 报关方式
        //   declareType: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 品名
        //   goodsName: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 货物类型
        //   goodsType: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 带电
        //   hasbatteryName: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 入仓号
        //   inNos: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 入仓时间
        //   inWarehouseTime: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 是否确认
        //   isConfirm: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 业务类型
        //   jobType: {
        //     en: '',
        //     cn: ''
        //   },
        //   // linkid
        //   linkid: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 物流单号
        //   logisticsNo: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 付款方
        //   payType: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 件数
        //   piece: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 粉末液体
        //   powderliquidName: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 客户单号
        //   refno: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 退税细腻些
        //   taxFefund: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 运输方式
        //   transport: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 类型
        //   type: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 货值
        //   valueGoods: {
        //     en: '',
        //     cn: ''
        //   },
        //   // 重量
        //   weight: {
        //     en: '',
        //     cn: ''
        //   }
        // }
      ],
      //移动端语言：CN:中文，EN：英文
      mobileLang: 'CN'
    }
  },
  computed: {
    deviceType() {
      if (this.windowWidth < 768) return 'mobile';
      if (this.windowWidth < 1024) return 'tablet';
      return 'desktop';
    },
    layoutClass() {
      return {
        'mobile-layout': this.deviceType === 'mobile',
        'tablet-layout': this.deviceType === 'tablet',
        'desktop-layout': this.deviceType === 'desktop'
      };
    }
  },
  watch: {
    windowWidth(newWidth, oldWidth) {
      // 当窗口宽度变化时，执行一些操作
      console.log(`窗口宽度从 ${oldWidth} 变为 ${newWidth}`);
      console.log("widnow", window)
      // 例如，根据不同宽度应用不同布局
    }
  },
  mounted() {
    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleResize);
    // 初始化数据
    this.initData()
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    /**
     * @param getBool: false:保存，true：确认并提交
     * */
    async submitFormVal(getBool) {
      // if (this.confirmWords.join('').length != 4) {
      //   return this.$message.warning("请完整填写柜号")
      // }
      let isAllRight = this.inOrderList.every(item => {
        return Number(item.valueGoods.en) > 0
      })
      if (!isAllRight) {
        return this.$message.warning("货值必须大于0,请重新填写货值金额")
      }
      // if (!this.submitForm.goodsValue.en) {
      //   return this.$message.warning("请填写货值(USD)")
      // }
      let params = {
        // 提交时间
        confirmTime: '',
        // 提交人
        confirmer: this.submitMan,
        valueGoodsInformationDTO: [
          //   {
          //   // 是否确认    0未确认 1确认
          //   isConfirm: getBool ? 1 : 0,
          //   // 业务id
          //   linkid: this.getType.linkId,
          //   // 业务类型, 关联不同业务类型（整柜：C，工单：A
          //   type: this.getType.type,
          //   // 货值
          //   valueGoods: this.submitForm.goodsValue.en,
          //   // 柜号
          //   cntNo: this.submitForm.cntNo.en + this.confirmWords.join('')
          // }
        ]
      }
      params.valueGoodsInformationDTO = this.inOrderList.map(item => {
        return {
          // 是否确认    0未确认 1确认
          isConfirm: getBool ? 1 : 0,
          // 业务id
          linkid: item.linkid.en,
          // 业务类型, 关联不同业务类型（整柜：C，工单：A
          type: item.type.en,
          // 货值
          valueGoods: item.valueGoods.en,
          // 柜号
          cntNo: item.cntNo.en
        }
      })
      let requestUrl = "/valueGoods/informationSave"
      const getRes = await this.axios.post(requestUrl, params
      )
      if (getRes.data.code == 200) {
        this.$message.success(getRes.data.message)
        this.initData()
      } else if (getRes.data.code == -1) {
        this.$message.warning(getRes.data.message)
      }

    },
    // 货值金额修改
    handleMoneyInput(val, index) {
      if (typeof Number(val) === 'number' && Number(val) > 0) {
        this.inOrderList[index]['valueGoods'].en = Number(val)
        this.inOrderList[index]['valueGoods'].cn = Number(val)
      } else {
        this.inOrderList[index]['valueGoods'].en = 0
        this.inOrderList[index]['valueGoods'].cn = 0
      }

    },
    // 初始化数据
    async initData() {
      this.inOrderList = []
      let requestUrl = "/valueGoods/information/"
      console.log("window.location.search", window.location)
      // const urlParams = new URLSearchParams(window.hash);
      const urlParams = this.$route.query.customerId
      requestUrl += urlParams
      const res = await this.axios.get(requestUrl)
      if (Array.isArray(res.data.data.valueGoodsInformationDTO) && res.data.data.valueGoodsInformationDTO.length > 0) {
        res.data.data.valueGoodsInformationDTO.forEach((item, index) => {
          this.inOrderList.push(
            {
              // 品牌
              brandName: {
                en: '',
                cn: ''
              },
              // 体积
              cbm: {
                en: '',
                cn: ''
              },
              // 计费重量
              chargWeight: {
                en: '',
                cn: ''
              },
              // 柜号
              cntNo: {
                en: '',
                cn: ''
              },
              // 目的国
              countryName: {
                en: '',
                cn: ''
              },
              // 用户名
              customername: {
                en: '',
                cn: ''
              },
              // 清关方式
              customsType: {
                en: '',
                cn: ''
              },
              // 报关方式
              declareType: {
                en: '',
                cn: ''
              },
              // 品名
              goodsName: {
                en: '',
                cn: ''
              },
              // 货物类型
              goodsType: {
                en: '',
                cn: ''
              },
              // 带电
              hasbatteryName: {
                en: '',
                cn: ''
              },
              // 入仓号
              inNos: {
                en: '',
                cn: ''
              },
              // 入仓时间
              inWarehouseTime: {
                en: '',
                cn: ''
              },
              // 是否确认
              isConfirm: {
                en: '',
                cn: ''
              },
              // 业务类型
              jobType: {
                en: '',
                cn: ''
              },
              // linkid
              linkid: {
                en: '',
                cn: ''
              },
              // 物流单号
              logisticsNo: {
                en: '',
                cn: ''
              },
              // 付款方
              payType: {
                en: '',
                cn: ''
              },
              // 件数
              piece: {
                en: '',
                cn: ''
              },
              // 粉末液体
              powderliquidName: {
                en: '',
                cn: ''
              },
              // 客户单号
              refno: {
                en: '',
                cn: ''
              },
              // 退税细腻些
              taxFefund: {
                en: '',
                cn: ''
              },
              // 运输方式
              transport: {
                en: '',
                cn: ''
              },
              // 类型
              type: {
                en: '',
                cn: ''
              },
              // 货值
              valueGoods: {
                en: '',
                cn: ''
              },
              // 重量
              weight: {
                en: '',
                cn: ''
              },
              // 品牌
              brandName: {
                en: '',
                cn: ''
              },
              // 带电
              hasbatteryName: {
                en: '',
                cn: ''
              },
              // 粉末液体
              powderliquidName: {
                en: '',
                cn: ''
              }
            }
          )
          for (let itemName in item) {
            this.inOrderList[index][itemName]['cn'] = item[itemName]
          }
        });
      } else {
        this.inOrderList = []
        return
      }
      if (Array.isArray(res.data.data.valueGoodsInformationDTOEn) && res.data.data.valueGoodsInformationDTOEn.length > 0) {
        res.data.data.valueGoodsInformationDTOEn.forEach((item, index) => {
          for (let itemName in item) {
            this.inOrderList[index][itemName]['en'] = item[itemName]
          }
        });
      } else {
        this.inOrderList = []
        return
      }
    },
    //移动端切换语言
    changeMobileLang(val) {
      // this.mobileLang = val
      this.languageType = val
    },
    /**
     * 切换当前查看入仓单
     * @param previewIndex 入仓单序号
     * */
    changePreviewIndex(previewIndex) {
      this.previewIndex = previewIndex
      window.scrollTo({ top: this.previewIndex * 650, behavior: 'smooth' });
    },
    /**
     * 切换语言
     * @param val 
     * */
    changeLang(val) {
      this.languageType = val
    },
    handleResize() {
      console.log(" window.innerWidth", window.innerWidth)
      this.windowWidth = window.innerWidth;
    }
  }
}
</script>
 <style>
/* 基础样式与重置 */

#warehouseReceipt {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: fit-content;
  user-select: none;
}

.warehouse_PC {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: fit-content;
}

.warehouse_PC_con {
  position: relative;
  width: 50%;
  height: fit-content;
  min-width: 600px;
  background-color: #fff;
  border-radius: 10px;
}

.warehouse_PC_head {
  box-sizing: border-box;
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  border-bottom: 1px solid rgb(208, 208, 208);
  padding: 10px 0px;
}

.warehosue_PC_warning {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 20px;
  user-select: none;
  z-index: 9;
}

.warehouse_warning_chose {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.el-button {
  box-sizing: border-box;
  width: fit-content;
  height: 32px;
  line-height: 32px;
  margin: 0;
  padding: 0;
  padding: 0 12px;
}

.warehouse_warn_words {
  color: rgb(224, 0, 17);
  margin-top: 10px;
}

.warehouse_in_order {
  height: fit-content;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  padding-bottom: 170px;
}

.warehouse_order_choices {
  width: 100%;
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #fff;
  padding-bottom: 10px;
  z-index: 9;
  padding-top: 10px;
  /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) */
}

.warehouse_choices_title {
  color: #606266;
  font-size: 18px;
  font-weight: 500;
  user-select: none;
}

.warehouse_choices_ul {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  height: fit-content;
  padding-left: 20px;
}

.warehosue_choices_li {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid #e4e7ed;
  color: #606266;
  cursor: pointer;
  user-select: none;
}

.active_preview {
  background-color: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
}

.warehouse_orders {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: fit-content;
  /* max-height: 800px; */
  /* border: 1px solid #F2F6FC; */
  margin-top: 20px;
  border-radius: 10px;
}

.warehouse_orders_item {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: 600px;
  background-color: #fff;
  border-radius: 5px;
  padding: 10px;
  font-size: 18px;
  color: #606266;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.warehouse_item_title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 48px;
}

.warehouse_value_input {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  color: rgb(224, 0, 17);
}

.warehouse_value_title {
  width: fit-content;
}

.warehouse_value_input .el-input {
  width: 200px;
  height: 32px !important;
}

.warehouse_value_input .el-input__inner {
  height: 32px;
  color: rgb(224, 0, 17);
}

.warehouse_orders_con {
  width: 100%;
  height: 520px;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(12, 1fr);
  border: 1px solid #909399;
  /* padding-bottom: 100px; */
}

.warehouse_con_son {
  border: 1px solid #909399;
  border-top: none;
  border-left: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 10px;
}

.warehouse_con_son:nth-child(1) {
  grid-row: 1/2;
  grid-column: 1/2;
}

.warehouse_con_son:nth-child(2) {
  grid-row: 1/2;
  grid-column: 2/4;
}

.warehouse_con_son:nth-child(3) {
  grid-row: 1/2;
  grid-column: 4/5;
}

.warehouse_con_son:nth-child(4) {
  grid-row: 1/2;
  grid-column: 5/7;
  border-right: none;
}

.warehouse_con_son:nth-child(5) {
  grid-row: 2/3;
  grid-column: 1/2;
}

.warehouse_con_son:nth-child(6) {
  grid-row: 2/3;
  grid-column: 2/4;
}

.warehouse_con_son:nth-child(7) {
  grid-row: 2/3;
  grid-column: 4/5;
}

.warehouse_con_son:nth-child(8) {
  grid-row: 2/3;
  grid-column: 5/7;
  border-right: none;
}

.warehouse_con_son:nth-child(9) {
  grid-row: 3/4;
  grid-column: 1/2;
}

.warehouse_con_son:nth-child(10) {
  grid-row: 3/4;
  grid-column: 2/4;
}

.warehouse_con_son:nth-child(11) {
  grid-row: 3/4;
  grid-column: 4/5;
}

.warehouse_con_son:nth-child(12) {
  grid-row: 3/4;
  grid-column: 5/7;
  border-right: none;
}

.warehouse_con_son:nth-child(13) {
  grid-row: 4/5;
  grid-column: 1/2;
}

.warehouse_con_son:nth-child(14) {
  grid-row: 4/5;
  grid-column: 2/7;
  border-right: none;
}

.warehouse_con_son:nth-child(15) {
  grid-row: 5/6;
  grid-column: 1/7;
  border-right: none;
}

.warehouse_con_son:nth-child(16) {
  grid-row: 6/7;
  grid-column: 1/2;
}

.warehouse_con_son:nth-child(17) {
  grid-row: 6/7;
  grid-column: 2/7;
  border-right: none;
}

.warehouse_con_son:nth-child(18) {
  grid-row: 7/8;
  grid-column: 1/2;
}

.warehouse_con_son:nth-child(19) {
  grid-row: 7/8;
  grid-column: 2/4;
}

.warehouse_con_son:nth-child(20) {
  grid-row: 7/8;
  grid-column: 4/5;
}

.warehouse_con_son:nth-child(21) {
  grid-row: 7/8;
  grid-column: 5/7;
  border-right: none;
}

.warehouse_con_son:nth-child(22) {
  grid-row: 8/9;
  grid-column: 1/2;
}

.warehouse_con_son:nth-child(23) {
  grid-row: 8/9;
  grid-column: 2/4;
}

.warehouse_con_son:nth-child(24) {
  grid-row: 8/9;
  grid-column: 4/5;
}

.warehouse_con_son:nth-child(25) {
  grid-row: 8/9;
  grid-column: 5/7;
  border-right: none;
}

.warehouse_con_son:nth-child(26) {
  grid-row: 9/10;
  grid-column: 1/2;
}

.warehouse_con_son:nth-child(27) {
  grid-row: 9/10;
  grid-column: 2/4;
}

.warehouse_con_son:nth-child(28) {
  grid-row: 9/10;
  grid-column: 4/5;
}

.warehouse_con_son:nth-child(29) {
  grid-row: 9/10;
  grid-column: 5/7;
  border-right: none;
}

.warehouse_con_son:nth-child(30) {
  grid-row: 10/11;
  grid-column: 1/2;
}

.warehouse_con_son:nth-child(31) {
  grid-row: 10/11;
  grid-column: 2/7;
  border-right: none;
}

.warehouse_con_son:nth-child(32) {
  grid-row: 11/12;
  grid-column: 1/7;
  border-right: none;
}

.warehouse_con_son:nth-child(33) {
  grid-row: 12/13;
  grid-column: 1/2;
  border-bottom: none;
}

.warehouse_con_son:nth-child(34) {
  grid-row: 12/13;
  grid-column: 2/4;
  border-bottom: none;
}

.warehouse_con_son:nth-child(35) {
  grid-row: 12/13;
  grid-column: 4/5;
  border-bottom: none;
}

.warehouse_con_son:nth-child(36) {
  grid-row: 12/13;
  grid-column: 5/7;
  border-bottom: none;
  border-right: none;
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
}

.warehouse_PC_bottom {
  position: fixed;
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 140px;
  background-color: #fff;
}

.warehouse_PC_bottom .el-input {
  width: 200px;
  height: 32px !important;
}

.warehouse_PC_bottom .el-input__inner {
  height: 32px;
  color: rgb(224, 0, 17);
}

.warehouse_bottom_first {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  height: 60px;
  padding-right: 20px;
}

.warehouse_bottom_second {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 30px;
  border-top: 1px solid #909399;
  padding-top: 20px;
}

.warehouse_bottom_second .el-button {
  height: 40px;
  padding: 0 20px;
  font-size: 17px;
  font-weight: 500;
  border-radius: 10px;
}

.warehouse_bottom_second .el-button:first-child {
  border: 1px solid #409eff;
  color: #409eff;
}

.warehouse_bottom_second .el-button:last-child {
  background-color: #409eff;
  color: #fff;
}

.warehouse_Mobile {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  padding-bottom: 130px;
}

.warehouse_Mobile_title {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  height: 80px;
  background-color: rgb(57, 192, 87);
  padding-bottom: 20px;
  color: #fff;
  font-size: 18px;
}

.warehouse_Mobile_warning {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 10px;
  color: #ee3330;
  background-color: #ffeeef;
  font-size: 14px;
  font-weight: bold;
}

.warehouse_Mobile_con {
  box-sizing: border-box;
  width: 100%;
  height: fit-content;
  padding: 10px;
  /* background-color: red; */
}

.warehouse_Mobile_lang {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  padding-left: 10px;
  color: #606266;
  width: 100%;
  height: 60px;
  background-color: #fff;
  border-radius: 10px;
}

.Mobile_chose_btn {
  box-sizing: border-box;
  width: fit-content;
  height: 32px;
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e7ed;
  border-radius: 20px;
}

.Mobile_btn_active {
  border-color: #39c057;
  color: #39c057;
}

.warehouse_inOrder_list {
  box-sizing: border-box;
  width: 100%;
  height: fit-content;
  background-color: #f9f9f9;
  margin-top: 10px;
}

.warehouse_inOrder_ul {
  box-sizing: border-box;
  width: 100%;
  height: fit-content;
  padding: 10px;
  list-style: none;
  background-color: #fff;
  border-radius: 5px;
}

.warehouse_inOrder_li {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  height: fit-content;
  margin-top: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  padding: 10px;
  border-radius: 5px;
}

.warehouse_inOrder_li:first-child {
  margin-top: 0px;
}

.inOrder_li_cus {
  border-left: 4px solid #39c057;
  padding-left: 5px;
  color: #303133;
  font-weight: 500;
}

.inOrder_li_money {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: rgb(224, 0, 17);
}

.inOrder_li_money .el-input {
  width: 200px;
  height: 32px !important;
}

.inOrder_li_money .el-input__inner {
  height: 32px;
  color: rgb(224, 0, 17);
}

.inOrder_li_form {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  background-color: #f9f9f9;
  padding: 10px;
  padding-top: 0px;
}

.inOrder_li_form > div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  border-bottom: 1px solid #ebeef5;
}

.inOrder_li_form > div > div:first-child {
  flex: 2;
  color: #606266;
}

.inOrder_li_form > div > div:last-child {
  flex: 3;
  color: #303133;
  font-weight: 500;
}

.mobile_submit_bottom {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 120px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  background-color: #fff;
}

.mobile_submit_man {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 50px;
  border-bottom: 1px solid #ebeef5;
}

.mobile_submit_contact {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100px;
  color: #606266;
  font-size: 16px;
  font-weight: 500;
}

.mobile_submit_man .el-input__inner {
  width: 100%;
  height: 32px;
  border: none;
}

.mobile_submit_btns {
  box-sizing: border-box;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0 10px;
}

.mobile_submit_btns .el-button {
  box-sizing: border-box;
  height: 42px;
  border-radius: 20px;
  font-size: 18px;
  font-weight: 500;
}

.mobile_submit_btns .el-button:first-child {
  flex: 3;
  color: #39c057;
  border: 1px solid #39c057;
}

.mobile_submit_btns .el-button:last-child {
  flex: 5;
  background-color: #39c057;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/goodsValue/warehouseReceipt.vue